// src/pages/help/topics/graphiquesBacktest.js
// Guide « Graphiques & Backtest » (FMReplay). Contenu validé — modifications ici.
export const fr = {
  title: "Graphiques & Backtest",
  tagline: "FMReplay : rejouer l'historique et tester une stratégie",
  readMin: 7,
  intro:
    "FMReplay est l'outil de backtest de FullMetrix, utilisable directement dans MetaTrader 5. Il permet de rejouer l'historique d'un marché, analyser les graphiques dans le passé, tester une stratégie, simuler des prises de position, observer les résultats obtenus et s'entraîner sans intervenir sur le marché en temps réel.",
  brief: [
    "Récupérer FMReplay et la licence liée à l'abonnement FullMetrix",
    "Préparer MetaTrader 5 et ajouter l'adresse de vérification de licence",
    "Rejouer un marché et simuler des positions sans toucher au compte réel",
  ],
  steps: [
    {
      title: "Télécharger l'outil et la licence",
      text: "Ouvre la section Backtest de FullMetrix, télécharge FMReplay et récupère la licence associée à ton compte.",
    },
    {
      title: "Préparer MetaTrader 5",
      text: "Outils → Options (ou Paramètres) → Expert Advisors : active le trading algorithmique, active les WebRequest pour les URL listées, ajoute l'adresse de vérification de licence indiquée dans la section Backtest, puis valide.",
    },
    {
      title: "Installer FMReplay",
      text: "Fichier → Ouvrir le dossier des données → dossier MQL5 : place les fichiers FMReplay dans les dossiers indiqués par le tutoriel.",
    },
    {
      title: "Redémarrer et lancer",
      text: "Redémarre MT5 ou actualise le navigateur, ouvre un graphique, lance FMReplay et vérifie que le trading algorithmique et la vérification de licence sont actifs.",
    },
    {
      title: "Lancer une session de backtest",
      text: "Sélectionne un marché et une période historique, fais avancer le graphique progressivement et simule tes positions.",
    },
  ],
  tips: [
    "L'adresse WebRequest de FMReplay n'est PAS https://ia.fullmargin.net (qui sert à l'Agent IA) : utilise l'adresse de vérification de licence affichée dans la section Backtest. Les deux peuvent être enregistrées en même temps dans MT5.",
    "Une vidéo tutorielle est disponible dans la section Backtest.",
    "La licence est liée à l'abonnement FullMetrix : aucun achat séparé.",
    "Vérifie que tu es bien dans l'environnement FMReplay avant de commencer une simulation.",
  ],
  faq: [
    {
      q: "Qu'est-ce que FMReplay ?",
      a:
        "FMReplay est l'outil de backtest de FullMetrix, utilisable directement dans MetaTrader 5.\n\n" +
        "Il permet de :\n" +
        "• rejouer l'historique d'un marché\n" +
        "• analyser les graphiques dans le passé\n" +
        "• tester une stratégie\n" +
        "• simuler des prises de position\n" +
        "• observer les résultats obtenus\n" +
        "• s'entraîner sans intervenir sur le marché en temps réel",
    },
    {
      q: "Sur quels marchés peut-on l'utiliser ?",
      a:
        "FMReplay peut être utilisé sur les marchés disponibles dans MetaTrader 5, notamment :\n" +
        "• le Forex\n" +
        "• les indices boursiers\n" +
        "• les indices synthétiques\n" +
        "• les matières premières\n" +
        "• les cryptomonnaies\n" +
        "• les autres actifs proposés par le broker\n\n" +
        "La disponibilité des actifs dépend du broker et du compte MT5 utilisé.",
    },
    {
      q: "Que faut-il faire pour utiliser FMReplay ?",
      a:
        "L'utilisateur doit :\n\n" +
        "1. ouvrir la section Backtest de FullMetrix\n" +
        "2. télécharger l'outil FMReplay\n" +
        "3. récupérer la licence associée à son compte\n" +
        "4. préparer MetaTrader 5\n" +
        "5. installer FMReplay dans MT5\n" +
        "6. ajouter l'adresse de vérification de licence dans les WebRequest autorisés\n" +
        "7. lancer l'outil sur un graphique\n\n" +
        "Une vidéo tutorielle est disponible dans la section Backtest pour présenter l'installation et l'utilisation de l'outil.",
    },
    {
      q: "Comment préparer MetaTrader 5 ?",
      a:
        "Dans MetaTrader 5 :\n\n" +
        "1. Clique sur Outils.\n" +
        "2. Ouvre Options ou Paramètres.\n" +
        "3. Accède à la section Expert Advisors.\n" +
        "4. Active le trading algorithmique.\n" +
        "5. Active l'autorisation des WebRequest pour les URL listées.\n" +
        "6. Ajoute l'adresse de vérification de licence indiquée dans la section Backtest de FullMetrix.\n" +
        "7. Valide les modifications.",
    },
    {
      q: "Quelle adresse WebRequest faut-il utiliser ?",
      a:
        "FMReplay utilise une adresse WebRequest spécifique pour vérifier la validité de la licence.\n\n" +
        "Cette adresse est différente de : https://ia.fullmargin.net\n\n" +
        "L'adresse https://ia.fullmargin.net sert au fonctionnement de l'Agent IA.\n\n" +
        "Pour FMReplay, l'utilisateur doit obligatoirement ajouter l'adresse de vérification de licence affichée dans la section Backtest.\n\n" +
        "Les deux adresses peuvent être enregistrées en même temps dans MetaTrader 5.",
    },
    {
      q: "Comment fonctionne la licence ?",
      a:
        "Une licence FMReplay est attribuée automatiquement à l'utilisateur lorsqu'il possède un abonnement FullMetrix actif.\n\n" +
        "Depuis la section Backtest, il peut :\n" +
        "• télécharger FMReplay\n" +
        "• consulter ou récupérer sa licence\n" +
        "• retrouver l'adresse WebRequest nécessaire\n" +
        "• accéder au tutoriel d'installation\n\n" +
        "La licence permet au système de vérifier que l'utilisateur dispose bien d'un accès valide à l'outil.",
    },
    {
      q: "Faut-il acheter une licence séparément ?",
      a:
        "Non.\n\n" +
        "La licence FMReplay est liée à l'abonnement FullMetrix de l'utilisateur.\n\n" +
        "Si l'abonnement n'est plus actif, l'accès à l'outil ou à certaines de ses fonctions peut être suspendu.",
    },
    {
      q: "Comment installer FMReplay dans MT5 ?",
      a:
        "Après le téléchargement :\n\n" +
        "1. Ouvre MetaTrader 5.\n" +
        "2. Clique sur Fichier → Ouvrir le dossier des données.\n" +
        "3. Ouvre le dossier MQL5.\n" +
        "4. Place les fichiers FMReplay dans les dossiers indiqués dans le tutoriel.\n" +
        "5. Redémarre MetaTrader 5 ou actualise le navigateur.\n" +
        "6. Ouvre un graphique.\n" +
        "7. Lance FMReplay.\n" +
        "8. Vérifie que le trading algorithmique et la vérification de licence sont actifs.",
    },
    {
      q: "Que peut-on faire pendant un backtest ?",
      a:
        "Pendant une session, l'utilisateur peut notamment :\n" +
        "• sélectionner un marché\n" +
        "• choisir une période historique\n" +
        "• faire avancer le graphique progressivement\n" +
        "• analyser le marché sans voir la suite\n" +
        "• simuler des achats et des ventes\n" +
        "• placer un Stop Loss et un Take Profit\n" +
        "• clôturer les positions simulées\n" +
        "• observer les gains et les pertes\n" +
        "• évaluer l'efficacité d'une stratégie",
    },
    {
      q: "Les positions simulées sont-elles envoyées sur le compte réel ?",
      a:
        "Non.\n\n" +
        "Les positions prises dans FMReplay servent uniquement au backtest et à l'entraînement.\n\n" +
        "Elles ne doivent pas ouvrir de positions réelles sur le compte de trading.\n\n" +
        "Il est néanmoins recommandé de vérifier que l'utilisateur se trouve bien dans l'environnement FMReplay avant de commencer une simulation.",
    },
    {
      q: "Faut-il installer l'Agent IA pour utiliser FMReplay ?",
      a:
        "Non.\n\n" +
        "FMReplay et l'Agent IA sont deux outils différents.\n\n" +
        "• L'Agent IA connecte le compte MT5 à FullMetrix.\n" +
        "• FMReplay permet de rejouer les graphiques et de réaliser des backtests.\n\n" +
        "FMReplay utilise sa propre licence et sa propre adresse WebRequest de vérification.",
    },
    {
      q: "Faut-il réinstaller FMReplay à chaque utilisation ?",
      a:
        "Non.\n\n" +
        "L'installation se fait normalement une seule fois sur le terminal MetaTrader 5.\n\n" +
        "L'utilisateur devra recommencer l'installation uniquement si :\n" +
        "• MetaTrader 5 a été désinstallé\n" +
        "• les fichiers FMReplay ont été supprimés\n" +
        "• l'outil a été installé sur un autre terminal\n" +
        "• une mise à jour exige le remplacement des fichiers",
    },
    {
      q: "Que faire si FMReplay ne fonctionne pas ?",
      a:
        "Vérifie en priorité :\n" +
        "• que le trading algorithmique est activé\n" +
        "• que la bonne adresse WebRequest a été ajoutée\n" +
        "• que la licence est valide\n" +
        "• que l'abonnement FullMetrix est actif\n" +
        "• que les fichiers sont installés dans les bons dossiers\n" +
        "• que MetaTrader 5 a été redémarré ou actualisé\n" +
        "• que l'outil est bien lancé sur un graphique\n\n" +
        "Il faut également vérifier que l'adresse utilisée est bien celle de la licence FMReplay et non uniquement https://ia.fullmargin.net.",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• une capture de la licence\n" +
        "• une capture des WebRequest autorisés\n" +
        "• une capture de FMReplay dans MT5\n" +
        "• le message d'erreur affiché\n" +
        "• une description précise du problème",
    },
  ],
  related: ["strategy-hub", "abonnement-paiements", "agent-ia-mt5"],
};

export const en = {
  title: "Charting & Backtest",
  tagline: "FMReplay: replay history and test a strategy",
  readMin: 7,
  intro:
    "FMReplay is the FullMetrix backtest tool, used directly inside MetaTrader 5. It lets you replay a market's history, analyse past charts, test a strategy, simulate positions, observe the results and practise without touching the live market.",
  brief: [
    "Get FMReplay and the licence tied to your FullMetrix subscription",
    "Prepare MetaTrader 5 and add the licence verification address",
    "Replay a market and simulate positions without touching the live account",
  ],
  steps: [
    {
      title: "Download the tool and the licence",
      text: "Open the FullMetrix Backtest section, download FMReplay and get the licence attached to your account.",
    },
    {
      title: "Prepare MetaTrader 5",
      text: "Tools → Options (or Settings) → Expert Advisors: enable algorithmic trading, enable WebRequest for listed URLs, add the licence verification address shown in the Backtest section, then confirm.",
    },
    {
      title: "Install FMReplay",
      text: "File → Open Data Folder → MQL5 folder: place the FMReplay files in the folders shown in the tutorial.",
    },
    {
      title: "Restart and launch",
      text: "Restart MT5 or refresh the Navigator, open a chart, launch FMReplay and check that algorithmic trading and licence verification are active.",
    },
    {
      title: "Run a backtest session",
      text: "Select a market and a historical period, step the chart forward and simulate your positions.",
    },
  ],
  tips: [
    "The FMReplay WebRequest address is NOT https://ia.fullmargin.net (that one is for the AI Agent): use the licence verification address shown in the Backtest section. Both can be registered in MT5 at the same time.",
    "A video tutorial is available in the Backtest section.",
    "The licence is tied to the FullMetrix subscription: no separate purchase.",
    "Check you are really in the FMReplay environment before starting a simulation.",
  ],
  faq: [
    {
      q: "What is FMReplay?",
      a:
        "FMReplay is the FullMetrix backtest tool, used directly inside MetaTrader 5.\n\n" +
        "It lets you:\n" +
        "• replay a market's history\n" +
        "• analyse past charts\n" +
        "• test a strategy\n" +
        "• simulate positions\n" +
        "• observe the results\n" +
        "• practise without touching the live market",
    },
    {
      q: "Which markets can I use it on?",
      a:
        "FMReplay can be used on the markets available in MetaTrader 5, including:\n" +
        "• Forex\n" +
        "• stock indices\n" +
        "• synthetic indices\n" +
        "• commodities\n" +
        "• cryptocurrencies\n" +
        "• the other assets offered by the broker\n\n" +
        "Asset availability depends on the broker and the MT5 account used.",
    },
    {
      q: "What do I need to use FMReplay?",
      a:
        "You must:\n\n" +
        "1. open the FullMetrix Backtest section\n" +
        "2. download the FMReplay tool\n" +
        "3. get the licence attached to your account\n" +
        "4. prepare MetaTrader 5\n" +
        "5. install FMReplay in MT5\n" +
        "6. add the licence verification address to the allowed WebRequest URLs\n" +
        "7. launch the tool on a chart\n\n" +
        "A video tutorial is available in the Backtest section covering installation and use.",
    },
    {
      q: "How do I prepare MetaTrader 5?",
      a:
        "In MetaTrader 5:\n\n" +
        "1. Click Tools.\n" +
        "2. Open Options or Settings.\n" +
        "3. Go to the Expert Advisors section.\n" +
        "4. Enable algorithmic trading.\n" +
        "5. Enable WebRequest for listed URLs.\n" +
        "6. Add the licence verification address shown in the FullMetrix Backtest section.\n" +
        "7. Confirm the changes.",
    },
    {
      q: "Which WebRequest address should I use?",
      a:
        "FMReplay uses a specific WebRequest address to verify the licence.\n\n" +
        "That address is different from: https://ia.fullmargin.net\n\n" +
        "https://ia.fullmargin.net is used by the AI Agent.\n\n" +
        "For FMReplay you must add the licence verification address shown in the Backtest section.\n\n" +
        "Both addresses can be registered in MetaTrader 5 at the same time.",
    },
    {
      q: "How does the licence work?",
      a:
        "An FMReplay licence is granted automatically when you have an active FullMetrix subscription.\n\n" +
        "From the Backtest section you can:\n" +
        "• download FMReplay\n" +
        "• view or retrieve your licence\n" +
        "• find the required WebRequest address\n" +
        "• open the installation tutorial\n\n" +
        "The licence lets the system verify you have valid access to the tool.",
    },
    {
      q: "Do I have to buy a licence separately?",
      a:
        "No.\n\n" +
        "The FMReplay licence is tied to your FullMetrix subscription.\n\n" +
        "If the subscription is no longer active, access to the tool or some of its features can be suspended.",
    },
    {
      q: "How do I install FMReplay in MT5?",
      a:
        "After downloading:\n\n" +
        "1. Open MetaTrader 5.\n" +
        "2. Click File → Open Data Folder.\n" +
        "3. Open the MQL5 folder.\n" +
        "4. Place the FMReplay files in the folders shown in the tutorial.\n" +
        "5. Restart MetaTrader 5 or refresh the Navigator.\n" +
        "6. Open a chart.\n" +
        "7. Launch FMReplay.\n" +
        "8. Check that algorithmic trading and licence verification are active.",
    },
    {
      q: "What can I do during a backtest?",
      a:
        "During a session you can:\n" +
        "• select a market\n" +
        "• choose a historical period\n" +
        "• step the chart forward\n" +
        "• analyse the market without seeing what comes next\n" +
        "• simulate buys and sells\n" +
        "• place a Stop Loss and a Take Profit\n" +
        "• close simulated positions\n" +
        "• observe profits and losses\n" +
        "• evaluate how effective a strategy is",
    },
    {
      q: "Are simulated positions sent to the live account?",
      a:
        "No.\n\n" +
        "Positions taken in FMReplay are only for backtesting and practice.\n\n" +
        "They must not open real positions on the trading account.\n\n" +
        "Still, check you are really in the FMReplay environment before starting a simulation.",
    },
    {
      q: "Do I need the AI Agent to use FMReplay?",
      a:
        "No.\n\n" +
        "FMReplay and the AI Agent are two different tools.\n\n" +
        "• The AI Agent connects the MT5 account to FullMetrix.\n" +
        "• FMReplay replays charts and runs backtests.\n\n" +
        "FMReplay uses its own licence and its own verification WebRequest address.",
    },
    {
      q: "Do I have to reinstall FMReplay every time?",
      a:
        "No.\n\n" +
        "Installation is normally done once per MetaTrader 5 terminal.\n\n" +
        "You only need to reinstall if:\n" +
        "• MetaTrader 5 was uninstalled\n" +
        "• the FMReplay files were deleted\n" +
        "• the tool was installed on another terminal\n" +
        "• an update requires replacing the files",
    },
    {
      q: "What if FMReplay does not work?",
      a:
        "Check first:\n" +
        "• that algorithmic trading is enabled\n" +
        "• that the right WebRequest address was added\n" +
        "• that the licence is valid\n" +
        "• that the FullMetrix subscription is active\n" +
        "• that the files are installed in the right folders\n" +
        "• that MetaTrader 5 was restarted or refreshed\n" +
        "• that the tool is launched on a chart\n\n" +
        "Also check the address used is the FMReplay licence one, and not only https://ia.fullmargin.net.",
    },
    {
      q: "How do I contact support?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "Please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• a screenshot of the licence\n" +
        "• a screenshot of the allowed WebRequest URLs\n" +
        "• a screenshot of FMReplay in MT5\n" +
        "• the error message displayed\n" +
        "• a precise description of the problem",
    },
  ],
  related: ["strategy-hub", "abonnement-paiements", "agent-ia-mt5"],
};
